import React from 'react';
import AgreementStudio from "./AgreementStudio";
import { useStoreActions } from "../../contexts";
import RestfulWrapper from "../RestfulWrapper/RestfulWrapper";
import { routes } from "../../constants";
export default function RelationshipDraftFetcher(props) {
  const {
    api
  } = useStoreActions();
  const {
    draftId
  } = props.match.params;
  return /*#__PURE__*/React.createElement(RestfulWrapper, {
    fetch: () => api.draft.getById(draftId),
    renderChild: _ref => {
      let {
        data
      } = _ref;
      return /*#__PURE__*/React.createElement(AgreementStudio, {
        draft: data,
        returnRoute: routes.draftsDashboard
      });
    }
  });
}